<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'App',
  methods: {
    ...mapActions({
      fetchConfigs: 'configs/fetchConfigs',
    })
  },
  created() {
    this.fetchConfigs()
  }
}
</script>